export type Links = {
	name: string
	href: string
	done: boolean
	external?: boolean
	pro?: boolean
	children?: Links
}[]

export const navigation: Links = [
	{
		name: 'Getting Started',
		href: '/getting-started',
		done: false,
		children: [
			{ name: 'Introduction', href: '/getting-started/introduction', done: false },
			{ name: 'Installation', href: '/getting-started/installation', done: false },
			{ name: 'Change log', href: '/getting-started/change-log', done: false },
			{ name: 'Roadmap', href: '/getting-started/roadmap', done: false },
		],
	},
	{
		name: 'Components',
		href: '/components',
		done: false,
		children: [
			{
				name: 'Layout',
				href: '/components/layout',
				done: false,
				children: [
					{ name: 'Container', href: '/components/layout/container', done: true },
					{ name: 'Flex', href: '/components/layout/flex', done: false },
					{ name: 'Grid', href: '/components/layout/grid', done: false },
					{ name: 'Sticky', href: '/components/layout/sticky', done: false },
					{ name: 'Separator', href: '/components/layout/separator', done: false },
					{ name: 'Aspect Ratio', href: '/components/layout/aspect-ratio', done: false },
					{ name: 'Visually Hidden', href: '/components/layout/visually-hidden', done: false },
				],
			},
			{
				name: 'Overlays',
				href: '/components/overlays',
				done: false,
				children: [
					{ name: 'Dialog', href: '/components/overlays/dialog', done: true },
					{ name: 'Popover', href: '/components/overlays/popover', done: false },
					{ name: 'Tooltip', href: '/components/overlays/tooltip', done: true },
					{ name: 'Dropdown Menu', href: '/components/modals/dropdown-menu', done: false },
					{ name: 'Context Menu', href: '/components/overlays/context-menu', done: false },
					{ name: 'Hover Card', href: '/components/overlays/hover-card', done: false },
				],
			},
			{
				name: 'Navigation',
				href: '/components/navigation',
				done: false,
				children: [
					{ name: 'Link', href: '/components/navigation/link', done: false },
					{ name: 'Navigation Menu', href: '/components/navigation/navigation-menu', done: false },
					{ name: 'Breadcrumbs', href: '/components/navigation/breadcrumbs', done: false },
					{ name: 'Pagination', href: '/components/navigation/pagination', done: false },
					{ name: 'Stepper', href: '/components/navigation/stepper', done: false },
				],
			},
			{
				name: 'Disclosure',
				href: '/components/disclosure',
				done: false,
				children: [
					{ name: 'Collapsible', href: '/components/disclosure/collapsible', done: false },
					{ name: 'Accordion', href: '/components/disclosure/accordion', done: false },
					{ name: 'Tabs', href: '/components/disclosure/tabs', done: false },
				],
			},
			{
				name: 'Typography',
				href: '/components/typography',
				done: false,
				children: [
					{ name: 'H1', href: '/components/typography/h1', done: false },
					{ name: 'H2', href: '/components/typography/h2', done: false },
					{ name: 'H3', href: '/components/typography/h3', done: false },
					{ name: 'H4', href: '/components/typography/h4', done: false },
					{ name: 'H5', href: '/components/typography/h5', done: false },
					{ name: 'H6', href: '/components/typography/h6', done: false },
					{ name: 'P', href: '/components/typography/p', done: false },
					{ name: 'Span', href: '/components/typography/span', done: false },
					{ name: 'Em', href: '/components/typography/em', done: false },
					{ name: 'I', href: '/components/typography/i', done: false },
					{ name: 'Strong', href: '/components/typography/strong', done: false },
					{ name: 'B', href: '/components/typography/b', done: false },
					{ name: 'Q', href: '/components/typography/q', done: false },
					{ name: 'Blockquote', href: '/components/typography/blockquote', done: false },
					{ name: 'Ul', href: '/components/typography/ul', done: false },
					{ name: 'Ol', href: '/components/typography/ol', done: false },
					{ name: 'Kbd', href: '/components/typography/kbd', done: false },
					{ name: 'Code', href: '/components/typography/code', done: false },
					{ name: 'Table of Contents', href: '/components/typography/table-of-contents', done: false },
				],
			},
			{
				name: 'Media',
				href: '/components/media',
				done: false,
				children: [
					{ name: 'Icon', href: '/components/media/icon', done: false },
					{ name: 'Avatar', href: '/components/media/avatar', done: false },
					{ name: 'Avatar Group', href: '/components/media/avatar-group', done: false },
					{ name: 'Image', href: '/components/media/image', done: false },
					{ name: 'Video', href: '/components/media/video', done: false },
				],
			},
			{
				name: 'Notifications',
				href: '/components/notifications',
				done: false,
				children: [
					{ name: 'Notification', href: '/components/notifications/notification', done: false },
					{ name: 'Notification Panel', href: '/components/notifications/notification-panel', done: false },
					{ name: 'Toast', href: '/components/notifications/toast', done: false },
					{ name: 'Alert', href: '/components/notifications/alert', done: false },
				],
			},
			{
				name: 'Status',
				href: '/components/status',
				done: false,
				children: [
					{ name: 'Spinner', href: '/components/status/spinner', done: false },
					{ name: 'Progress Bar', href: '/components/status/progress-bar', done: false },
				],
			},
			{
				name: 'Buttons',
				href: '/components/buttons',
				done: false,
				children: [
					{ name: 'Button', href: '/components/buttons/button', done: false },
					{ name: 'Burger Button', href: '/components/buttons/burger-button', done: false },
					{ name: 'Button Group', href: '/components/buttons/button-group', done: false },
				],
			},
			{
				name: 'Data Display',
				href: '/components/data-display',
				done: false,
				children: [
					{ name: 'Article Preview', href: '/components/data-display/article-preview', done: false },
					{ name: 'Badge', href: '/components/data-display/badge', done: false },
					{ name: 'Card', href: '/components/data-display/card', done: false },
					{ name: 'Command Line', href: '/components/data-display/command-line', done: false },
					{ name: 'Table', href: '/components/data-display/table', done: false },
					{ name: 'Tag', href: '/components/data-display/tag', done: false },
					{ name: 'Tag Group', href: '/components/data-display/tag-group', done: false },
					{ name: 'Tag Picker', href: '/components/data-display/tag-picker', done: false },
					{ name: 'Testimonial', href: '/components/data-display/testimonial', done: false },
					{ name: 'Product Tile', href: '/components/data-display/product-tile', done: false },
					{ name: 'Skeleton', href: '/components/data-display/skeleton', done: false },
					{ name: 'Statistic', href: '/components/data-display/statistic', done: false },
				],
			},
			{
				name: 'Data Entry',
				href: '/components/data-entry',
				done: false,
				children: [
					{ name: 'Address Input', href: '/components/data-entry/address-input', done: false },
					{ name: 'Checkbox', href: '/components/data-entry/checkbox', done: false },
					{ name: 'Calendar Input', href: '/components/data-entry/calendar-input', done: false },
					{ name: 'Calendar Range Input', href: '/components/data-entry/calendar-range-input', done: false },
					{ name: 'Color Picker', href: '/components/data-entry/color-picker', done: false },
					{ name: 'Currency Input', href: '/components/data-entry/currency-input', done: false },
					{ name: 'Credit Card Input', href: '/components/data-entry/credit-card-input', done: false },
					{ name: 'Date Input', href: '/components/data-entry/date-input', done: false },
					{ name: 'Date Picker', href: '/components/data-entry/date-picker', done: false },
					{ name: 'Date Range Input', href: '/components/data-entry/date-range-input', done: false },
					{ name: 'Date Range Picker', href: '/components/data-entry/date-range-picker', done: false },
					{ name: 'Fieldset', href: '/components/data-entry/fieldset', done: false },
					{ name: 'File Input', href: '/components/data-entry/file-input', done: false },
					{ name: 'File Dropzone', href: '/components/data-entry/file-dropzone', done: false },
					{ name: 'File Picker', href: '/components/data-entry/file-picker', done: false },
					{ name: 'Label', href: '/components/data-entry/label', done: false },
					{ name: 'Pin Input', href: '/components/data-entry/pin-input', done: false },
					{ name: 'Phone Number Input', href: '/components/data-entry/phone-number-input', done: false },
					{ name: 'Radio Button', href: '/components/data-entry/radio-button', done: false },
					{ name: 'Radio Group', href: '/components/data-entry/radio-group', done: false },
					{ name: 'Range Slider', href: '/components/data-entry/range-slider', done: false },
					{ name: 'Rating', href: '/components/data-entry/rating', done: false },
					{ name: 'Search Input', href: '/components/data-entry/search-input', done: false },
					{ name: 'Switch', href: '/components/data-entry/switch', done: false },
					{ name: 'Segmented Control', href: '/components/data-entry/segmented-control', done: false },
					{ name: 'Select', href: '/components/data-entry/select', done: false },
					{ name: 'Slider', href: '/components/data-entry/slider', done: false },
					{ name: 'Text Input', href: '/components/data-entry/text-input', done: false },
					{ name: 'Textarea', href: '/components/data-entry/textarea', done: false },
					{ name: 'Toggle', href: '/components/data-entry/toggle', done: false },
					{ name: 'Toggle Group', href: '/components/data-entry/toggle-group', done: false },
					{ name: 'URL Input', href: '/components/data-entry/url-input', done: false },
				],
			},
			{
				name: 'Forms',
				href: '/components/forms',
				done: false,
				children: [{ name: 'TBD', href: '/components/forms/tbd', done: false }],
			},
		],
	},
	{
		name: 'Legal',
		done: false,
		href: '/legal',
		children: [
			{ name: 'Privacy policy', href: '/legal#privacy-policy', done: false },
			{ name: 'Terms of use', href: '/legal#terms-of-use', done: false },
			{ name: 'License', href: '/legal#license', done: false },
		],
	},
	{
		name: 'Support',
		done: false,
		href: '/get-access',
		children: [
			{ name: 'Pricing', href: '/get-access', done: false },
			{ name: 'FAQ', href: '/get-access#faq', done: false },
		],
	},
]
